import { apiClient } from "helpers/api_helper";

export const getRewardReport = async (data: any) => {
    try {
        const response = await apiClient.get(`/api/v1/Report/GetRewardReport`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};